$(document).ready(() => {
  // ========= Initialize GSAP & Lenis Scroll =========
  gsap.registerPlugin(ScrollTrigger);

  const initGsapAndLenis = () => {
    const lenis = new Lenis();

    lenis.on("scroll", () => {
      ScrollTrigger.update();
    });

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    $(window).scrollTop(0);
    ScrollTrigger.refresh();
  };
  

  const customCarousel = () => {
  // ---------- Tunables (smoothened) ----------
  const WIDTH_MODE = "100vw"; // '100vw' | '100%' | 'max-px'
  const WIDTH_PX = 1200;      // used if WIDTH_MODE === 'max-px'
  const SIDE_RATIO = 0.25;    // left/right slide width fraction (for geometry only)
  const CENTER_RATIO = 0.35;  // center slide width fraction (for geometry only)
  const GAP_PX = 40;          // horizontal gap between slides
  const TILT_DEG = 8;         // slightly reduced tilt for smoother feel
  const CSS_FADE = 0.35;      // opacity for side slides

  // Smooth animation constants
  const DURATION = 0.75;         // a touch longer than before
  const ENTER_OVERSHOOT = 1.02;  // tiny overshoot for the incoming center
  const CENTER_SCALE = 1.0;      // center scale
  const SIDE_SCALE = 0.84;       // side scale (subtle difference from center)

  function applySliderWidth($root) {
    const $wrap = $root; // sbv-wrap
    if (WIDTH_MODE === "100vw") {
      $wrap.css({ "--slider-w": "100vw", "--slider-max": "100vw" });
    } else if (WIDTH_MODE === "100%") {
      $wrap.css({ "--slider-w": "100%", "--slider-max": "100%" });
    } else {
      $wrap.css({ "--slider-w": "100%", "--slider-max": WIDTH_PX + "px" });
    }
  }

  // Decode images to avoid pop-in when first shown
  function preloadSlides($slides) {
    $slides.find("img").each((_, img) => {
      if (img && img.decode) {
        img.decode().catch(() => {});
      }
    });
  }

  function cloneCenterMetaToArc($root, $slides, current) {
    const $live = $root.find(".sbv-liveMeta");
    const $src = $slides.eq(current).find(".sbv-meta");

    const $kicker = $src.find(".sbv-kicker, .kicker").first();
    const $name = $src.find(".sbv-name, .name").first();
    const $cta = $src.find(".sbv-cta, .cta").first();

    const frag = document.createDocumentFragment();
    if ($kicker.length) {
      const k = document.createElement("div");
      k.className = "sbv-kicker";
      k.textContent = $kicker.text();
      frag.appendChild(k);
    }
    if ($name.length) {
      const n = document.createElement("div");
      n.className = "sbv-name";
      n.textContent = $name.text();
      frag.appendChild(n);
    }
    if ($cta.length) {
      const a = document.createElement("a");
      a.className = "sbv-cta";
      a.href = $cta.attr("href") || "#";
      $cta.contents().each(function () {
        a.appendChild(this.cloneNode(true));
      });
      frag.appendChild(a);
    }

    $live.empty().append(frag);
  }

  function updateArcSideNames($root, $slides, current, LOOP) {
    const count = $slides.length;
    const leftIndex = LOOP ? (current - 1 + count) % count : current - 1;
    const rightIndex = LOOP ? (current + 1) % count : current + 1;

    const $left = $root.find(".sbv-sideLabel--left");
    const $right = $root.find(".sbv-sideLabel--right");

    // Left label
    if (leftIndex >= 0) {
      const leftName = $slides
        .eq(leftIndex)
        .find(".sbv-meta .sbv-name, .sbv-meta .name")
        .first()
        .text()
        .trim();
      if (leftName) {
        $left.text(leftName).css({ visibility: "visible", opacity: 1 });
      } else {
        $left.css({ visibility: "hidden", opacity: 0 }).text("");
      }
    } else {
      $left.css({ visibility: "hidden", opacity: 0 }).text("");
    }

    // Right label
    if (rightIndex <= count - 1) {
      const rightName = $slides
        .eq(rightIndex)
        .find(".sbv-meta .sbv-name, .sbv-meta .name")
        .first()
        .text()
        .trim();
      if (rightName) {
        $right.text(rightName).css({ visibility: "visible", opacity: 1 });
      } else {
        $right.css({ visibility: "hidden", opacity: 0 }).text("");
      }
    } else {
      $right.css({ visibility: "hidden", opacity: 0 }).text("");
    }
  }

  function updateDotVisibility($root, current, count, LOOP) {
    const $dotPrev = $root.find(".sbv-dotPrev");
    const $dotNext = $root.find(".sbv-dotNext");

    if (LOOP) {
      $dotPrev.removeClass("sbv-hidden");
      $dotNext.removeClass("sbv-hidden");
      return;
    }

    // hide left dot at the start; hide right dot at the end
    $dotPrev.toggleClass("sbv-hidden", current === 0);
    $dotNext.toggleClass("sbv-hidden", current === count - 1);
  }

  // For every carousel instance on the page
  $(".sbv-wrap").each(function () {
    const $root = $(this);
    const $slider = $root.find(".sbv-slider");
    const $track = $slider.find(".sbv-track");
    const $slides = $slider.find(".sbv-slide");

    const $prevBtn = $root.find(".sbv-prev");
    const $nextBtn = $root.find(".sbv-next");
    const $dotPrev = $root.find(".sbv-dotPrev");
    const $dotNext = $root.find(".sbv-dotNext");
    const $dotCenter = $root.find(".sbv-dotCenter");
    const $currentStart = $root.attr("data-startIndex");

    const count = $slides.length;
    const LOOP = String($root.data("loop")).toLowerCase() === "true";

    applySliderWidth($root);
    preloadSlides($slides);
    gsap.set($slides, {
      transformPerspective: 800,
      transformOrigin: "50% 60%",
      force3D: true,
      willChange: "transform, opacity"
    });

    let current = parseInt($currentStart, 10) || 0;
    let isAnimating = false;

    function computeFrame() {
      const W = $slider.innerWidth();
      const cw = Math.max(200, Math.round(W * CENTER_RATIO));
      const sw = Math.max(160, Math.round(W * SIDE_RATIO));
      const leftX = -(cw / 2 + GAP_PX + sw / 2);
      const rightX = -leftX;
      return { W, cw, sw, leftX, rightX };
    }

    function allowedRels() {
      if (count <= 1) return [0];
      if (!LOOP) {
        if (current === 0) return [0, +1];
        if (current === count - 1) return [-1, 0];
      }
      return [-1, 0, +1];
    }

    // Returns transform targets only (no width changes)
    function targetState(i, cur, frame) {
      const { leftX, rightX } = frame;
      let rel;
      if (LOOP) {
        rel = (i - cur + count) % count;
        if (rel > count / 2) rel -= count; // wrap to [-k..k]
      } else {
        rel = i - cur;
      }
      let x = 0,
        scale = CENTER_SCALE,
        rot = 0,
        z = 100;
      if (rel === -1) {
        x = leftX;
        scale = SIDE_SCALE;
        rot = TILT_DEG;
        z = 90;
      }
      if (rel === 1) {
        x = rightX;
        scale = SIDE_SCALE;
        rot = -TILT_DEG;
        z = 90;
      }
      return { rel, x, scale, rot, z };
    }

    function updateNavVisibility() {
      if (LOOP) {
        $prevBtn.removeClass("sbv-hidden");
        $nextBtn.removeClass("sbv-hidden");
        return;
      }
      $prevBtn.toggleClass("sbv-hidden", current === 0);
      $nextBtn.toggleClass("sbv-hidden", current === count - 1);
    }

    function layout(instant = false) {
      const frame = computeFrame();
      const allowed = allowedRels();

      const tl = gsap.timeline({
        defaults: { ease: "power3.out", duration: instant ? 0 : DURATION * 0.75 }
      });

      $slides.each(function (i) {
        const $el = $(this);
        const t = targetState(i, current, frame);
        const vis = allowed.includes(t.rel);

        $el.toggleClass("sbvOff", !vis);
        if (t.rel === 0) $el.removeClass("sbvFade").addClass("sbvCenter");
        else if (vis) $el.addClass("sbvFade").removeClass("sbvCenter");
        else $el.removeClass("sbvCenter sbvFade");

        tl.to(
          $el,
          {
            x: vis ? t.x : 0,
            scale: vis ? t.scale : SIDE_SCALE,
            rotateY: vis ? t.rot : 0,
            zIndex: vis ? t.z : 1,
            autoAlpha: vis ? (t.rel === 0 ? 1 : CSS_FADE) : 0,
            visibility: vis ? "visible" : "hidden"
          },
          0
        );
      });

      cloneCenterMetaToArc($root, $slides, current);
      updateArcSideNames($root, $slides, current, LOOP);
      updateNavVisibility();
      updateDotVisibility($root, current, count, LOOP);
      return tl;
    }

    function goTo(nextIndex, dir = +1) {
      if (isAnimating || nextIndex === current) return;
      if (!LOOP && (nextIndex < 0 || nextIndex > count - 1)) return;

      isAnimating = true;

      const prevIndex = current;
      current = LOOP ? (nextIndex + count) % count : nextIndex;

      const frame = computeFrame();
      const allowed = allowedRels();

      const prevT = targetState(prevIndex, current, frame);
      const nextT = targetState(current, current, frame);

      const $prev = $slides.eq(prevIndex);
      const $next = $slides.eq(current);

      // Prepare classes for end state
      $slides.each(function (i) {
        const t = targetState(i, current, frame);
        const vis = allowed.includes(t.rel);
        $(this)
          .toggleClass("sbvOff", !vis)
          .toggleClass("sbvCenter", t.rel === 0 && vis)
          .toggleClass("sbvFade", t.rel !== 0 && vis);
      });

      gsap.set($next, { zIndex: 1000 });

      const tl = gsap.timeline({ defaults: { ease: "power3.inOut" } });

      // Subtle camera tilt
      tl.to($track, { rotationY: dir * 3, duration: DURATION * 0.35, ease: "power2.out" }, 0);

      // Move background/sides first for intentional motion
      $slides.each(function (i) {
        if (i === prevIndex || i === current) return;
        const $el = $(this);
        const t = targetState(i, current, frame);
        const vis = allowed.includes(t.rel);

        tl.to(
          $el,
          vis
            ? {
                x: t.x,
                scale: t.scale,
                rotateY: t.rot,
                zIndex: t.z,
                autoAlpha: t.rel === 0 ? 1 : CSS_FADE,
                visibility: "visible",
                duration: DURATION * 0.65
              }
            : {
                autoAlpha: 0,
                visibility: "hidden",
                zIndex: 1,
                rotateY: 0,
                duration: DURATION * 0.5
              },
          0
        );
      });

      // Outgoing center → side: glide & resize (no hard fade)
      tl.to(
        $prev,
        {
          x: prevT.x,
          scale: prevT.scale,
          rotateY: prevT.rot,
          zIndex: prevT.z,
          autoAlpha: CSS_FADE,
          ease: "power3.inOut",
          duration: DURATION * 0.7
        },
        0.05
      );

      // Incoming center: small offset + gentle overshoot
      const slideOffset = Math.max(16, GAP_PX * 0.45);
      tl.fromTo(
        $next,
        {
          x: nextT.x - dir * slideOffset,
          scale: Math.max(nextT.scale * 0.96, SIDE_SCALE),
          autoAlpha: 0.95,
          rotateY: 0
        },
        {
          x: nextT.x,
          scale: nextT.scale * ENTER_OVERSHOOT,
          autoAlpha: 1,
          zIndex: 1000,
          duration: DURATION * 0.85,
          ease: "power3.out"
        },
        0.08
      ).to($next, { scale: nextT.scale, duration: DURATION * 0.25, ease: "power2.out" }, "-=0.12");

      // Return camera to neutral
      tl.to($track, { rotationY: 0, duration: DURATION * 0.35, ease: "power2.inOut" }, DURATION * 0.35);

      tl.eventCallback("onComplete", () => {
        const fr = computeFrame();
        $slides.each(function (i) {
          const t = targetState(i, current, fr);
          const vis = allowed.includes(t.rel);
          gsap.set(this, { zIndex: vis ? t.z : 1 });
        });
        cloneCenterMetaToArc($root, $slides, current);
        updateArcSideNames($root, $slides, current, LOOP);
        updateNavVisibility();
        updateDotVisibility($root, current, count, LOOP);
        isAnimating = false;
      });
    }

    // Events (all within this instance scope)
    $nextBtn.on("click", () =>
      goTo(LOOP ? (current + 1) % count : Math.min(current + 1, count - 1), +1)
    );
    $prevBtn.on("click", () =>
      goTo(LOOP ? (current - 1 + count) % count : Math.max(current - 1, 0), -1)
    );

    // Arc dots act as nav too
    $dotNext.on("click", () => $nextBtn.trigger("click"));
    $dotPrev.on("click", () => $prevBtn.trigger("click"));
    $dotCenter.on("click", () => {
      const $cta = $root.find(".sbv-liveMeta .sbv-cta").first();
      if ($cta.length) window.location.href = $cta.attr("href");
    });

    // Slide click moves to it (one step unless LOOP)
    $slides.each(function (i) {
      $(this).on("click", () => {
        if (!LOOP && Math.abs(i - current) > 1) return;
        const forward = LOOP
          ? (i - current + count) % count <= (current - i + count) % count
          : i >= current;
        goTo(i, forward ? +1 : -1);
      });
    });

    // Resize handling
    let resizeTO;
    $(window).on("resize", () => {
      clearTimeout(resizeTO);
      resizeTO = setTimeout(() => layout(true), 80);
    });

    // Initial layout + meta
    $slides.addClass("sbvFade").removeClass("sbvCenter sbvOff");
    layout(true);
  });
};


  // ===== scroll scale up animation ==---
  const scrollScaleUpMediaAnim = () => {
    const $container = $(".showScrollScaleAnim");
    const headerSelector = ".homeHeader";
    const headerActiveClass = "showBG";
    console.log("Calling Fucntion");

    // 2) Per-slide animations
    $(".showScrollScaleAnim .slideshow__slide").each(function (index) {
      const $slide = $(this);
      const $content = $slide.find(".content-over-media");
      console.log("before condition");
      if ($content.length === 0) return;
      console.log("After condition");
      // ensure starting values (optional, but makes it predictable)
      gsap.set($slide[0], {
        paddingTop: 28,
        paddingRight: 28,
        paddingBottom: 28,
        paddingLeft: 28,
        boxSizing: "border-box",
      });
      gsap.set($content[0], { scale: 1 });

      // Animate padding (28px → 0) with a bit of smoothing
      gsap.to($slide[0], {
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        ease: "none",
        scrollTrigger: {
          id: "slide-padding-" + (index + 1),
          trigger: $slide[0],
          start: "top top",
          // stretch the distance slightly so the change is more gradual
          end: "bottom top+=10%",
          scrub: 0.35, // << small smoothing duration for buttery motion
          markers: false,
          fastScrollEnd: true,
          invalidateOnRefresh: true,
          anticipatePin: 1, // helps if you later add pinning
        },
      });

      // Animate scale (1 → 1.3) with the same smoothing
      gsap.to($content[0], {
        scale: 1.3,
        ease: "none",
        scrollTrigger: {
          id: "content-scale-" + (index + 1),
          trigger: $slide[0],
          start: "top top",
          end: "bottom top+=10%",
          scrub: 0.35, // << same smoothing
          markers: false,
          fastScrollEnd: true,
          invalidateOnRefresh: true,
        },
      });
      ScrollTrigger.create({
        trigger: $slide[0],
        start: "top top",
        end: "bottom top",
        onEnter: () => {
          console.log("ON ENTER Removing class");
          $(headerSelector).removeClass(headerActiveClass);
        },
        onEnterBack: () => {
          // console.log("ON ENTER BACK Removing class");
          $(headerSelector).removeClass(headerActiveClass);
        },
        // Section has finished (scrolled past its end):
        onLeave: () => {
          // console.log("ON Leave Adding class");
          $(headerSelector).addClass(headerActiveClass);
        },
        onLeaveBack: () => {
          // no need to add class  when leave back to stay header same like init
          //  $(headerSelector).addClass(headerActiveClass);
        },
        // markers: true
      });
    });

    // Recalculate on resize/orientation changes
    ScrollTrigger.refresh();
  };

  // Initialize all on page
  // initGsapAndLenis();
  scrollScaleUpMediaAnim();
  customCarousel();
});
